import {
  toResponseError,
  type WorkflowData,
  type WorkflowUpdateInput,
  type WorkflowUpdateSuccess,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useWorkflowCache } from './cache'

export function useUpdateWorkflow(): UpdateHookResponse<WorkflowData, WorkflowData> {
  const mutation = useTantalimMutation<WorkflowUpdateInput, WorkflowUpdateSuccess>({
    url: '/workflow/update',
  })
  const cache = useWorkflowCache()

  async function update(unsaved: WorkflowData): Promise<WorkflowData> {
    try {
      const { workflow } = await mutation.mutateAsync({ workflow: unsaved })
      cache.replaceItem(workflow)
      cache.clearList()
      cache.clearReportColumns()
      return workflow
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
